/**
 * Dependency-free check for the server's due-lock refusal, so low-level error
 * handling (ErrorPackage, page-level 403 handlers) can recognize it without
 * pulling in the store or the survey start path (ClickUp 868k2749y).
 */

/** Matches QuizLockdownMiddleware::DUE_LOCKED_SURVEY_CODE. */
export const DUE_LOCKED_SURVEY_CODE = 'automated_survey_locked';

/**
 * Whether an axios error is the 403 QuizLockdownMiddleware returns while a
 * locked survey is due but unstarted. It is not an access problem: the learner
 * is moved into the survey instead of being shown the restricted page.
 *
 * @param {unknown} error
 * @returns {boolean}
 */
export function isDueLockRejection(error) {
    return error?.response?.status === 403 && error?.response?.data?.code === DUE_LOCKED_SURVEY_CODE;
}
